import { FC } from 'react';

import { TooltipProps } from 'recharts';
import { EStatisticType } from 'views/Statistics/StatisticsView.types';

import { Card, CardDescription, CardTitle } from 'components/ui/card';

import { MultipleTrendsLegend } from './MultipleTrendsLegend';
import { SingleTrendLegend } from './SingleTrendLegend';

type AnalyticsTooltipProps = TooltipProps<number, string> & {
  title: string;
  type: EStatisticType;
};

const PREVIOUS_DATA_KEY = 'previousValue';
const CURRENT_DATA_KEY = 'currentValue';

export const AnalyticsChartTooltip: FC<AnalyticsTooltipProps> = ({
  active,
  payload,
  label,
  title,
  type
}) => {
  if (!active || !payload?.length) {
    return null;
  }
  const currentData = payload.find((p) => p.dataKey === CURRENT_DATA_KEY);
  const previousData = payload.find((p) => p.dataKey === PREVIOUS_DATA_KEY);

  const renderLegend = () => {
    if (!previousData) {
      return (
        <SingleTrendLegend
          time={label}
          metricType={type}
          currentValue={currentData?.value ?? 0}
        />
      );
    }
    return (
      <MultipleTrendsLegend
        currentDate={label}
        previousDate={previousData?.payload?.previousDate}
        metricType={type}
        currentValue={currentData?.value ?? 0}
        previousValue={previousData?.value ?? 0}
      />
    );
  };

  return (
    <Card className="flex flex-col py-2 px-4 items-start gap-1 rounded-md border border-base-popover bg-base-popover shadow-md">
      {previousData !== undefined && (
        <CardTitle className="text-base-popoverForeground">{title}</CardTitle>
      )}
      <CardDescription>{renderLegend()}</CardDescription>
    </Card>
  );
}
